// Opções do vue-toastification. Antes o mesmo bloco estava copiado no
// api.service.js e três vezes no AlertasMixin.js. Centralizado aqui.
export const OPCOES_TOAST_BASE = {
  position: "top-center",
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 1,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
};

export const opcoesToast = (extras = {}) => ({
  ...OPCOES_TOAST_BASE,
  timeout: 3000,
  ...extras,
});

// Erro precisa de mais tempo de leitura que sucesso: a mensagem é mais longa
// e o usuário costuma precisar ler o que corrigir. 3s não dava.
export const opcoesToastErro = (extras = {}) =>
  opcoesToast({ toastClassName: "toast-erro", timeout: 8000, ...extras });
